<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 9.66602L16 12.666M16 12.666L13 15.666M16 12.666L8 12.666M21 12.666C21 17.6366 16.9706 21.666 12 21.666C7.02944 21.666 3 17.6366 3 12.666C3 7.69545 7.02944 3.66602 12 3.66602C16.9706 3.66602 21 7.69545 21 12.666Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
